module.exports = __webpack_public_path__ + "img/67_01.f3afb373.png";